import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

import {
  fulfillmentPickerStylesParams as sharedFulfillmentPickerStylesParams,
  type FulfillmentPickerStylesParams as SharedFulfillmentPickerStylesParams,
} from '../../../../../../components-shared/FulfillmentPicker/stylesParams';

export type DispatchInfoStylesParams = {
  dispatchInfoTextFont: StyleParamType.Font;
  dispatchInfoTextColor: StyleParamType.Color;
  dispatchInfoLinkFont: StyleParamType.Font;
  dispatchInfoLinkColor: StyleParamType.Color;
  dispatchInfoShowIcon: StyleParamType.Boolean;
  dispatchInfoIconSize: StyleParamType.Number;
  dispatchInfoIconColor: StyleParamType.Color;
};

export type FulfillmentPickerStylesParams =
  SharedFulfillmentPickerStylesParams & DispatchInfoStylesParams;

const dispatchInfoStylesParams = createStylesParams<DispatchInfoStylesParams>({
  dispatchInfoTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        htmlTag: 'p',
        size: params.isMobile ? 14 : 16,
      })(params),
  },
  dispatchInfoTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  dispatchInfoLinkFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        htmlTag: 'p',
        size: params.isMobile ? 14 : 16,
      })(params),
  },
  dispatchInfoLinkColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
  dispatchInfoShowIcon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  dispatchInfoIconSize: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isMobile }) => (isMobile ? 14 : 16),
  },
  dispatchInfoIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
});

export const fulfillmentPickerStylesParams = {
  ...sharedFulfillmentPickerStylesParams,
  ...dispatchInfoStylesParams,
};
